module.exports = __webpack_public_path__ + "media/images/vector/vector_1_xl-46de4c1d5983df3ca6a8155cda6cfccb.svg";